import React, { useEffect, useState } from 'react'
import ModalUserReimprimirDespachosFarmacia from './ModalUserReimprimirDespachosFarmacia'
import { getTipoDocumento, postReimprimirDespachoPrincipal } from '../../../services/FarmaciaRuta'
import ModalUserNoEncontrado from './ModalUserNoEncontrado'
import { UserTokenURL } from '../../../services/ApiHIS'
import axios from "axios";
import { useLocation } from 'react-router-dom';


const ModalReimprimirDespachosFarmacia = () => {
    const [modalOnReimprimirDespacho, setmodalOnReimprimirDespacho]=useState(false)
    const [modalOnUserNoEncontrado, setmodalOnUserNoEncontrado]=useState(false)
    const [tipoDocumento, settipoDocumento]=useState([])
    const [errorTipoDocumento, seterrorTipoDocumento]=useState('')
    const [errorNumeroDocumento, seterrorNumeroDocumento]=useState('')
    const [dataUserReimprimirDespacho, setdataUserReimprimirDespacho]=useState([])
    const [userdata, setuserdata]=useState({
      HISCKEY:'',
      HISTipDoc:''
    })
    const [loading,setloading]=useState(true)
    const reimprimirDespacho =(e)=>{
      e.preventDefault();
      setloading(false)
        // const dataUser={
        //     HISCKEY : e.target.identificacion.value,
        //     HISTipDoc : e.target.selectTipoDocumento.value
        // }
        const dataUser={
          HISCKEY : e.target.identificacion.value,//"16723746",
          HISTipDoc : e.target.selectTipoDocumento.value,//"CC",
          HISCSEC : '',
          HISCLPR : '',
          DSmFHrMov: "",//"2023-07-27", 
          fechaFin: ""//"2023-07-29"
      }
      setuserdata({
        HISCKEY:e.target.identificacion.value,
        HISTipDoc: e.target.selectTipoDocumento.value
      })
        console.log(dataUser,'user')
        postReimprimirDespachoPrincipal(dataUser).then((res)=>{
          if(res.data.length > 0){
            setloading(true)
            console.log(Object.values(res.data),'reimprimir')
            setdataUserReimprimirDespacho(Object.values(res.data))
            setmodalOnReimprimirDespacho(true)
          }else{
            setloading(true)
            setmodalOnUserNoEncontrado(true)
          }
          
        }).catch((error) => {
          setloading(true)
          setmodalOnUserNoEncontrado(true)
          console.log("Hubo un error al obtener los datos:", error);
        });

       
        
    }

    //token
  let query = new URLSearchParams(useLocation().search);
  let tokenCons = JSON.parse(query.get('token'));
  let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    useEffect(()=>{
        seterrorNumeroDocumento('Numero de Documento')
        seterrorTipoDocumento('Seleccionar tipo de documento')
        getTipoDocumento().then((res)=>{
            console.log(res.data,'tipo de documento')
            settipoDocumento(res.data)
    })
    },[])

    useEffect(()=>{
      //console.log(tokenCons,'tokenConstokenCons')
      const url = UserTokenURL() 
  
      // Configurar la cabecera con el token JWT
      const headers = {
        Authorization: `Bearer ${tokenCons}`,
      };
  
      // Realiza la petición con Axios
      axios.get(url, { headers })
      .then(response => {
        //console.log(response.data.user_data, 'data user');
  
        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
  
        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
        console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')
  
        // Resto del código...
      })
      .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
      });
    },[])
  return (

<>
        <div className="flex justify-center mt-12">
      <div className="w-96  border rounded-lg shadow-xl bg-white p-6">
        <h2 className="text-xl font-bold mb-4 text-center">Reimprimir Despacho</h2>
        <form onSubmit={reimprimirDespacho}>
        <div className="mb-4">
          <label className="block text-gray-700 text-lg font-bold mb-2" htmlFor="input1">
          Nro. Identificación
          </label>
          <input type="text" name="identificacion" id="number" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4" placeholder="123456789" required />
          {/* <p className="text-red-500 mt-1">{errorNumeroDocumento}</p> */}
        </div>

        <div className="mb-4">
          <label className="block text-gray-700 text-lg font-bold mb-2" htmlFor="input2">
          Tipo de documento
          </label>
          <select name="selectTipoDocumento" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4" required >
                     {/* <option value='0'>Todos los documentos</option> */}
                     {
                        tipoDocumento.map((item)=>(
                            <option value={item.MPTDoc} key={item.MPTDoc}>{item.MPTDesc} </option>
                        ))
                     }
                    
                </select>
                {/* {item.error && <p className="text-red-500 mt-1">{item.error}</p>} */}
                {/* <p className="text-red-500 mt-1">{errorTipoDocumento}</p> */}
        </div>

        <div className="flex justify-center p-4">
                         <button type="submit" className="bg-[#9e56fe] text-white px-4 py-2 rounded">
                             Consultar
                         </button>
                    </div>
                        
                    </form>
                           
      </div>
      {modalOnReimprimirDespacho ? <ModalUserReimprimirDespachosFarmacia setmodalOnReimprimirDespacho={setmodalOnReimprimirDespacho} dataUserReimprimirDespacho={dataUserReimprimirDespacho} userdata={userdata}/> : null}
      {modalOnUserNoEncontrado? <ModalUserNoEncontrado setmodalOnUserNoEncontrado={setmodalOnUserNoEncontrado}/>:null}
    </div>
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">      
                                  <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25">
                                    <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                                      <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                                      <p className="mt-4 text-lg">Cargando</p>
                                    </div>
                                  </div>                              
                                </div>
                            }   
    </>

  )
}

export default ModalReimprimirDespachosFarmacia